export default __webpack_public_path__ + "93a85a2b09867910208e519a231a1c8e.ico";